import {
  Calendar,
  Clock,
  ControlSlider,
  Settings,
  WarningTriangle
} from 'iconoir-react';
import moment from 'moment';
import { memo } from 'react';

import { Infos } from './components/StatusBody';
import {
  GenericCardRuntime,
  GenericCardRuntimeProps
} from './GenericCardRuntime';

import { parseCronExpression } from '~/common/helpers/cronValidation';
import i18n from '~/common/helpers/i18n';

type SchedulerCardRuntimeProps = GenericCardRuntimeProps;

export const SchedulerCardRuntime = memo((props: SchedulerCardRuntimeProps) => {
  const { isValidCron, humanReadableCron } = parseCronExpression(
    props.deployment.pipeline.triggerSpec.cronExpression
  );
  if (!isValidCron) {
    return (
      <GenericCardRuntime
        {...props}
        infos={[
          [
            {
              icon: WarningTriangle,
              title: i18n.t('scenes.runtime.labels.recurring_intervals') || '',
              value: i18n.t('scenes.runtime.labels.invalid_cron_expression')
            }
          ]
        ]}
      />
    );
  }
  const infos: Infos = [
    [
      {
        icon: Calendar,
        value: moment(props.deployment.startTime, 'x').format(
          'DD/MM/YYYY HH:mm:ss'
        )
      },
      {
        icon: Settings,
        title: i18n.t('label.engine_version') || '',
        value: props.disabledMenu
          ? null
          : props.deployment.deploymentStatus?.pipelineEngineVersion?.replace(
              /^([^.]*\.[^.]*\.[^.]*).*/,
              '$1'
            )
      }
    ],
    [
      {
        icon: ControlSlider,
        title: i18n.t('scenes.runtime.labels.conc_scheduling') || '',
        titleTooltip:
          i18n.t('scenes.runtime.labels.conc_scheduling_tooltip') || '',
        value: props.deployment.pipeline?.triggerSpec.concurrentScheduling
          ? 'on'
          : 'off'
      },
      {
        icon: Clock,
        title: i18n.t('scenes.runtime.labels.recurring_intervals') || '',
        value: humanReadableCron,
        valueTooltip: humanReadableCron
      }
    ]
  ];

  return <GenericCardRuntime {...props} infos={infos} />;
});
